// @ts-nocheck

import { use, useEffect, useState } from "react";
import { db } from "../../db/db";
import { useLiveQuery } from "dexie-react-hooks";

import { API_BASE_URL as publicApiUrl } from "../../utils/api";

function BodyMapsSend({id}) {
  const bodymaps = useLiveQuery(async () => {
    return await db.bodymaps.where("postedSuccessfully").equals(0).toArray();
  });
  useEffect(() => {
    if (bodymaps) {
      if (bodymaps?.length > 0) {
        bodymaps.map((bodymap) => {
          const form = new FormData();
          form.append("date_of_report", bodymap.id);
          form.append("save_new_record", "true");
          form.append("c", "ltgb2qzc31qn88xor");
          form.append("t", "l4_body_map");
          form.append("rdpartyintid_5", bodymap.id);
          if (id) {
            form.append("logged_by_8", id["id"]);
          }
          form.append("client_name_5", bodymap.clientId)
          form.append("description_7", bodymap.description_7);
          form.append("body_area", bodymap.body_area);
          form.append("photo_upload", bodymap.photo_upload);
          

          console.log(form);
          fetch(`${publicApiUrl}/bodymap`, {
            body: form,
            method: "POST",
          })
            .then((res) => res.json())
            .then(() => {
              db.bodymaps
                .update(bodymap["id"], {
                  postedSuccessfully: 1,
                })
                .catch((error) => {
                  console.log(error);
                });
            });
        });
      }
    }
  }, [bodymaps]);

  return <></>;
}

export default BodyMapsSend;
